import { inject, injectable } from '@servicetitan/react-ioc';
import { PasswordValidation } from '../../api/password-validator.api';
import { runInAction, observable, makeObservable } from 'mobx';
import { debounce } from 'debounce';

export interface ICompromizedPasswordStore {
    isPasswordStrong: boolean;
    isValid: boolean;
    isValidating: boolean;
    validate: (password: string) => Promise<void>;
}

@injectable()
export class CompromizedPasswordStore implements ICompromizedPasswordStore {
    constructor(@inject(PasswordValidation) private passwordValidationApi: PasswordValidation) {
        makeObservable(this);
    }

    @observable
    isPasswordStrong = false;

    @observable
    isValid = false;
    @observable
    isValidating = false;

    private validator!: Function & { clear: Function };

    private checkPasswordCompromization = async (password: string) => {
        const res = await this.passwordValidationApi.validatePassword({
            newPassword: password,
        });
        runInAction(() => (this.isPasswordStrong = res.data));
        return res.data;
    };

    validate = async (password: string) => {
        runInAction(() => (this.isValidating = true));
        if (this.validator) {
            this.validator.clear();
        }
        this.validator = debounce(async () => {
            let isValid = false;
            try {
                isValid = await this.checkPasswordCompromization(password);
            } finally {
                runInAction(() => {
                    this.isValid = isValid;
                    this.isValidating = false;
                });
            }
        }, 500);
        this.validator();
    };
}
